<div>
	<app-dropdown-columns-actions
		[columns]="columns()"
		[translationPrefix]="'optionsBoardWidgetActions.columns.'"
		(columnsChange)="onChangeColumns($event)"
	/>
</div>
